function formatBytes(bytes) {
  if (!Number.isFinite(bytes) || bytes <= 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export default function ChatbotFileList({ files = [], compact = false, onRemove }) {
  if (files.length === 0) return null;

  return (
    <div className={`chatbot-files ${compact ? "chatbot-files--compact" : ""}`.trim()}>
      {files.map((file) => {
        const label = file.virtual_path || file.filename || file.name;
        const key = file.id || `${file.source || "upload"}-${label}-${file.size || file.byte_size}`;
        // An image the model produced is worth showing; its filename is a
        // container file id and tells the user nothing.
        const body = file.preview_url ? (
          <img
            className="chatbot-files__preview"
            src={file.preview_url}
            alt="Genereret billede"
            loading="lazy"
          />
        ) : (
          <>
            <i className="bi bi-file-earmark" aria-hidden="true" />
            <span className="chatbot-files__name" title={label}>{label}</span>
            <small>{formatBytes(file.byte_size ?? file.size)}</small>
          </>
        );

        return (
          <div
            className={`chatbot-files__item ${file.preview_url ? "chatbot-files__item--preview" : ""}`.trim()}
            key={key}
          >
            {file.url ? (
              <a href={file.url} className="chatbot-files__link">{body}</a>
            ) : (
              <span className="chatbot-files__link">{body}</span>
            )}
            {onRemove ? (
              <button type="button" onClick={() => onRemove(file)} aria-label={`Fjern ${label}`}>
                <i className="bi bi-x" aria-hidden="true" />
              </button>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
